export const LOTTIE_VISUAL = `
  visualType
  lottieFileDesktop { url }
  lottieFileMobile { url }
`
